import gql from 'graphql-tag';

export default gql`
  query practitioners($search: String) {
    practitioners(search: $search) {
      id
      name
      given
      family
      active
      messagingEnabled
    }
  }
`;
